import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {SETTINGS} from "../config/common.settings";

@Injectable({
  providedIn: 'root'
})


export class UserService {
  loggedInUserNameSubject = new BehaviorSubject('');
  loggedInUserProfilePicSubject = new BehaviorSubject('');
  loggedInUser = new BehaviorSubject({});
  constructor(private http: HttpClient) { }


  softDeleteUser(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(`${SETTINGS.BASE_API}/admin/soft-delete/${id}`)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  createUser(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${SETTINGS.BASE_API}/admin/create`, payload).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error);
        },
      });
    });
  }

  updateUser(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${SETTINGS.BASE_API}/admin/update`, payload).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error);
        },
      });
    });
  }

  getPagedUsers(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${SETTINGS.BASE_API}/admin/get-paged`, payload).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  getOneUserById(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/admin/admin/${id}`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }



  resetUserPasswordEmail(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/admin/reset-password/${id}`)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }
  getOneUser(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/user/user/${id}`).subscribe({
        next: (response: any) => {
          this.loggedInUser.next(response);
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

}
